import HttpClient from '../../../core/HttpClient';
import Failure from '../../../core/Failure';

export interface SendPasswordResetEmailRequest {
  email: string;
  firstname?: string;
}

export interface SendPasswordResetEmailResponse {
  success: boolean;
  error?: string;
}

async function sendPasswordResetEmail(
  request: SendPasswordResetEmailRequest
): Promise<SendPasswordResetEmailResponse> {
  try {
    if (!request.email) {
      throw new SendPasswordResetEmailFailure('Email requis', 'email-required');
    }

    await HttpClient.post(
      '/auth/password-reset/leedflow',
      {
        email: request.email,
        firstname: request.firstname || '',
      },
      ''
    );

    return { success: true };
  } catch (e) {
    console.error('Error sending password reset email:', e);

    if (e instanceof SendPasswordResetEmailFailure) {
      return {
        success: false,
        error: e.message,
      };
    }

    return {
      success: false,
      error: e instanceof Error ? e.message : 'Erreur inconnue',
    };
  }
}

export class SendPasswordResetEmailFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default sendPasswordResetEmail;
